/* eslint-disable @typescript-eslint/no-explicit-any */
import AsyncLock from 'async-lock';

const lockSymbol: unique symbol = Symbol.for('lockSymbol');
export const LOCK_DEFAULT_NAME = 'default';
export function autoQueue(
  lockName: string,
  queuedType: 'Queued' | 'WaitForPrevious' = 'Queued'
): (target: object, key: string, descriptor: TypedPropertyDescriptor<(...args: any[]) => Promise<any>>) => void {
  return function (
    target: object,
    propertyKey: string,
    descriptor: TypedPropertyDescriptor<(...args: any[]) => Promise<any>>
  ): void {
    const originalMethod = descriptor.value;
    descriptor.value = async function (...args: any[]): Promise<any> {
      let lock: AsyncLock;
      if (!(lockSymbol in this && this[lockSymbol])) {
        lock = new AsyncLock();
        (this as unknown as { [lockSymbol]: AsyncLock })[lockSymbol] = lock;
      } else {
        lock = (this as unknown as { [lockSymbol]: AsyncLock })[lockSymbol];
      }
      if (!lock.isBusy(lockName)) {
        return await lock.acquire(lockName, async () => await originalMethod!.apply(this, args));
      }
      if (queuedType === 'Queued') {
        return await lock.acquire(lockName, async () => await originalMethod!.apply(this, args));
      } else {
        return await lock.acquire(lockName, async () => {});
      }
    };
  };
}
